export function decoupledPromise() {
  let promise: Promise<unknown>, resolve: (value?: unknown) => void
  promise = new Promise(res => resolve = res)
  return { promise, resolve }
}
